import { takeLatest, call, fork, put } from 'redux-saga/effects';
import { saveScoreboardUrl } from '../actions';
import { getScoreboardData } from '../../dataProviders';
import { BYO_GET_SCOREBOARD_URL } from '../constants';
export function* getAppSaga() {
    try {
        // @ts-ignore: Yield error
        const response = yield call(getScoreboardData);
        yield put(saveScoreboardUrl(response.launch_link || ''));
    }
    catch (e) {
        yield put(saveScoreboardUrl(''));
    }
}
export function* getAppWatcher() {
    yield takeLatest(BYO_GET_SCOREBOARD_URL, getAppSaga);
}
const appSagas = [
    fork(getAppWatcher),
];
export default appSagas;
